<!-- This component is used to display the tools panel content for the map, which
is consistent between the desktop and mobile views. It provides functionality to toggle
zoom to the selected feature and to navigate to the assigned island. -->

<template>
  <div class="p-3">
    <!-- Zoom Settings Section -->
    <h3 class="text-muted text-uppercase fw-bold mb-2 h6 fs-6">
      Zoom Settings
    </h3>
    <div
      class="form-check form-switch d-flex align-items-center justify-content-between"
    >
      <input
        class="form-check-input mt-0"
        type="checkbox"
        role="switch"
        :id="`zoom-to-selected${idSuffix}`"
        :checked="zoomToSelected"
        :aria-checked="zoomToSelected"
        aria-label="Zoom to selected item"
        @change="$emit('toggleZoom', $event.target.checked)"
      />
      <label
        class="form-check-label fs-6"
        style="cursor: pointer; user-select: none"
        :for="`zoom-to-selected${idSuffix}`"
      >
        Zoom to Selected
      </label>
    </div>

    <!-- Assigned Island Section -->
    <h3 class="text-muted text-uppercase fw-bold mb-2 h6 fs-6 mt-3">
      Assigned Island
    </h3>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm w-100 d-flex align-items-center justify-content-center gap-2"
      :disabled="!assignedIslandId"
      :title="
        !assignedIslandId
          ? 'No island has been assigned to you yet'
          : 'Navigate to your assigned island'
      "
      @click="$emit('goToAssignedIsland')"
    >
      <i class="bi bi-star-fill" aria-hidden="true"></i>
      Go to My Island
    </button>
    <p v-if="!assignedIslandId" class="text-muted small mt-2 mb-0">
      <i class="bi bi-info-circle me-1" aria-hidden="true"></i>
      No island assigned.
    </p>
  </div>
</template>

<script>
export default {
  name: "ToolsPanelContent",
  props: {
    zoomToSelected: {
      type: Boolean,
      required: true
    },
    assignedIslandId: {
      type: String,
      default: null
    },
    idSuffix: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleZoom", "goToAssignedIsland"]
};
</script>

<style scoped></style>
